import { m } from "framer-motion";
import clsx from "clsx";
import { ComponentPropsWithoutRef } from "react";
import { opacityAnimation } from "@ui/animation/opacity-animation";
import { isMobileApp } from "@common/core/platform-detection";

interface UnderlayProps extends Omit<
  ComponentPropsWithoutRef<"div">,
  "onAnimationStart" | "onDragStart" | "onDragEnd" | "onDrag"
> {
  position?: "fixed" | "absolute";
  className?: string;
  isTransparent?: boolean;
  disableInitialTransition?: boolean;
  zIndex?: number;
}
export function Underlay({
  position = "absolute",
  className,
  isTransparent = false,
  disableInitialTransition,
  zIndex = 10,
  ...domProps
}: UnderlayProps) {
  const shouldBlur = !isTransparent && !isMobileApp();

  return (
    <m.div
      {...domProps}
      className={clsx(
        className,
        !isTransparent && "bg-black/80",
        shouldBlur && "backdrop-blur-sm",
        `inset-0 h-full w-full`,
        position,
      )}
      style={{ zIndex }}
      aria-hidden
      initial={disableInitialTransition ? undefined : { opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      {...opacityAnimation}
      transition={{ duration: 0.15 }}
    />
  );
}
